export function getColorForString(string: string): {
  bgColor: string;
  textColor: string;
  borderColor: string;
} {
  const colors = [
    {
      bgColor: 'oklch(0.99 0.06 290)',
      textColor: 'oklch(0.15 0.12 290)',
      borderColor: 'oklch(0.70 0.12 290)'
    },
    {
      bgColor: 'oklch(0.98 0.08 320)',
      textColor: 'oklch(0.12 0.12 320)',
      borderColor: 'oklch(0.65 0.12 320)'
    },
    {
      bgColor: 'oklch(0.99 0.06 80)',
      textColor: 'oklch(0.25 0.12 80)',
      borderColor: 'oklch(0.75 0.12 80)'
    },
    {
      bgColor: 'oklch(0.99 0.08 45)',
      textColor: 'oklch(0.20 0.15 45)',
      borderColor: 'oklch(0.70 0.15 45)'
    },
    {
      bgColor: 'oklch(0.99 0.05 220)',
      textColor: 'oklch(0.10 0.08 220)',
      borderColor: 'oklch(0.55 0.15 220)'
    },
    {
      bgColor: 'oklch(0.99 0.06 190)',
      textColor: 'oklch(0.18 0.10 190)',
      borderColor: 'oklch(0.65 0.12 190)'
    },
    {
      bgColor: 'oklch(0.97 0.02 180)',
      textColor: 'oklch(0.12 0.01 180)',
      borderColor: 'oklch(0.55 0.05 180)'
    }
  ];

  return colors[string.length % colors.length];
}
